import { CheckCircle2 } from "lucide-react";
import Reveal from "@/components/Reveal";

const POINTS = [
  "Fully NSW licensed, insured & police-checked team",
  "Trusted by homeowners, builders, architects & designers across Sydney — references available on request",
  "Drop sheets, dust protection, daily clean-down",
  "Written, itemised quotes — never an open-book invoice",
  "Family-owned. Local. Quietly proud of our work.",
];

export default function About() {
  return (
    <section
      data-testid="about-section"
      id="about"
      className="relative bg-[#080A0B] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-16 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <Reveal className="lg:col-span-6 order-2 lg:order-1">
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-10 h-px bg-[#3FB8DC]" />
            <span className="eyebrow">The Studio</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] leading-[1.04] tracking-tight">
            A family trade with
            <br />
            <span className="italic text-[#A1A1AA]">an architect's </span>
            <span className="text-[#3FB8DC]">eye.</span>
          </h2>

          <p className="mt-8 text-[#A1A1AA] text-base md:text-lg leading-relaxed">
            Today, we specialise in high-end renovations, custom homes, commercial
            plumbing and maintenance, focusing on the plumbing systems that sit
            behind the finishes and fixtures our clients see and use every day.
          </p>
          <p className="mt-5 text-[#A1A1AA] text-base md:text-lg leading-relaxed">
            We're proud to work alongside homeowners, builders, architects and
            designers across Sydney, with much of our work coming from repeat
            clients and referrals. We believe in building long-term relationships
            through reliability, communication and a standard of work we're proud
            to put our name to.
          </p>

          <ul className="mt-10 space-y-4">
            {POINTS.map((p) => (
              <li
                key={p}
                data-testid={`about-point-${p.slice(0, 14).replace(/\s/g, "-").toLowerCase()}`}
                className="flex items-start gap-4 text-[#F4F0EB]/90 text-sm md:text-base"
              >
                <CheckCircle2 className="w-5 h-5 text-[#3FB8DC] mt-0.5 flex-shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-12 pt-8 border-t border-[#27272A]">
            <p className="font-serif-display italic text-2xl text-[#F4F0EB]/90">
              "Do it the way you'd want it in your own home."
            </p>
            <p className="mt-3 eyebrow" style={{ fontSize: "0.6rem" }}>
              — Marc, Founder
            </p>
          </div>
        </Reveal>

        <Reveal delay={180} className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative">
            <div className="zoom-wrap aspect-[2/3] border border-[#27272A] overflow-hidden bg-[#080A0B]">
              <img
                src="/assets/about-studio.jpg"
                alt="MarX Plumbing project"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="hidden md:block absolute -bottom-10 -left-10 w-48 h-48 bg-[#3FB8DC] z-[-1]" />
            <div className="hidden md:flex absolute -bottom-6 -right-6 bg-[#080A0B] border border-[#27272A] p-6 flex-col gap-1">
              <span className="eyebrow" style={{ fontSize: "0.6rem" }}>Est. 2023</span>
              <span className="font-serif-display text-2xl text-[#F4F0EB]">Concord, NSW</span>
              <span className="text-[#A1A1AA] text-xs">Family owned & operated</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
